const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-white border-t border-gray-200">
      <div className="max-w-7xl mx-auto px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 mb-16">
          {/* ロゴとタグライン */}
          <div className="md:col-span-5 space-y-6">
            <div className="flex items-center space-x-3">
              <div className="w-10 h-10 flex items-center justify-center border border-black">
                <span className="text-xl font-light text-black">E</span>
              </div>
              <span className="text-sm tracking-[0.2em] font-light text-black">
                EXHIBITION
              </span>
            </div>
            <p className="text-sm font-light text-gray-600 leading-relaxed max-w-sm">
              富裕層・企業向けに特化したオーダーメイドイベントプロデュース。ブランドの格にふさわしい、少人数・高密度のイベントを企画・運営いたします。
            </p>
          </div>

          {/* リンク */}
          <div className="md:col-span-3 space-y-4">
            <h3 className="text-xs tracking-[0.2em] text-gray-400 uppercase mb-6">Navigation</h3>
            <ul className="space-y-3">
              <li>
                <a href="#services" className="text-sm font-light text-gray-700 hover:text-black transition-colors duration-300 cursor-pointer">
                  提供サービス
                </a>
              </li>
              <li>
                <a href="#portfolio" className="text-sm font-light text-gray-700 hover:text-black transition-colors duration-300 cursor-pointer">
                  実績
                </a>
              </li>
              <li>
                <a href="#mission" className="text-sm font-light text-gray-700 hover:text-black transition-colors duration-300 cursor-pointer">
                  MISSION
                </a>
              </li>
              <li>
                <a href="#contact" className="text-sm font-light text-gray-700 hover:text-black transition-colors duration-300 cursor-pointer">
                  お問い合わせ
                </a>
              </li>
            </ul>
          </div>

          {/* コンタクト情報 */}
          <div className="md:col-span-4 space-y-4">
            <h3 className="text-xs tracking-[0.2em] text-gray-400 uppercase mb-6">Contact</h3>
            <div className="space-y-3">
              <p className="text-base font-light text-gray-700">
                bytwotempos@gmail.com
              </p>
              <p className="text-base font-light text-gray-700">
                
              </p>
              <p className="text-base font-light text-gray-700">
                
              </p>
            </div>
          </div>
        </div>

        {/* ボトムバー */}
        <div className="pt-8 border-t border-gray-200">
          <div className="flex flex-col md:flex-row items-center justify-between space-y-4 md:space-y-0">
            <p className="text-xs font-light text-gray-500">
              © {currentYear} Exhibition. All rights reserved.
            </p>
            <a 
              href="https://readdy.ai/?ref=logo" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-xs font-light text-gray-500 hover:text-black transition-colors duration-300 cursor-pointer"
            >
              Powered by Readdy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
